var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-[100vh] bg-white flex items-center justify-center"},[_c('color-model',{model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }